import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { Users } from "lucide-react";
import { DashboardLayout } from "@/components/layouts/DashboardLayout";

export const Route = createFileRoute("/_authenticated/instructor")({
  head: () => ({ meta: [{ title: "Instructor Portal — Code Cubs" }] }),
  component: InstructorLayout,
});

const navItems = [{ to: "/instructor", label: "مجموعاتي", icon: Users, exact: true }];

function InstructorLayout() {
  return (
    <RoleGuard allowedRoles={["instructor", "admin"]}>
      <DashboardLayout title="لوحة المعلم" navItems={navItems}>
        <Outlet />
      </DashboardLayout>
    </RoleGuard>
  );
}
